
<br/>
<div style="text-align: center; ">
  <h1 style="font-weight: bold; color:#1c2453;">{{ "title_"+articleType | translate}}</h1>
</div>

<div>
  <mat-form-field appearance="standard">
    <mat-label>{{"common.search" | translate}}</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Search columns" #input>
  </mat-form-field>
  <div style="float: right; display: inline;">
    <button (click)="onClickAdd()"  mat-raised-button>{{ "newArticle" | translate}}</button>
  </div>
  <table mat-table matTableResponsive [dataSource]="dataSource" matSort class="mat-elevation-z16">
    <ng-container matColumnDef="articleId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"articleId" | translate}}  </th>
      <td mat-cell *matCellDef="let article"> {{article.article.id}} </td>
    </ng-container>
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"title" | translate}}  </th>
      <td mat-cell *matCellDef="let article"> {{article.title}} </td>
    </ng-container>
    <ng-container matColumnDef="article.author">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"author" | translate}}  </th>
      <td mat-cell *matCellDef="let article"> {{article.article.author}} </td>
    </ng-container>
    <ng-container matColumnDef="article.articleType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"articleType" | translate}}  </th>
      <td mat-cell *matCellDef="let article"> {{article.article.articleType | translate}}</td>
    </ng-container>
    <ng-container matColumnDef="article.created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"created" | translate}}  </th>
      <td mat-cell *matCellDef="let article"> {{article.article.created}}</td>
    </ng-container>
    <ng-container matColumnDef="article.published">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"published" | translate}}  </th>
      <td mat-cell *matCellDef="let article"> {{article.article.published}}</td>
    </ng-container>
    <ng-container matColumnDef="article.articleStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"articleStatus" | translate}}  </th>
      <td mat-cell *matCellDef="let article"> {{article.article.articleStatus | translate}}</td>
    </ng-container>
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let article">
        <button mat-icon-button class="edit-btn" matTooltip="{{ 'common.tooltip.edit' | translate }}"
        matTooltipPosition="above" (click)="onClickEdit(article.article.id, article.id)">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="publish">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let article">
        <button mat-icon-button class="edit-btn" matTooltip="{{ 'common.tooltip.publish' | translate }}"
        matTooltipPosition="above" (click)="onClickPublish(article.article.id)" [disabled]="article.article.articleStatus === 'PUBLISHED'">
          <mat-icon>publish</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="hide">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let article">
        <button mat-icon-button class="edit-btn" matTooltip="{{ 'common.tooltip.hide' | translate }}"
        matTooltipPosition="above" (click)="onClickHide(article.article.id)" [disabled]="article.article.articleStatus === 'HIDDEN'">
          <mat-icon>visibility_off</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let article">
        <button mat-icon-button class="edit-btn" matTooltip="{{ 'common.tooltip.delete' | translate }}"
        matTooltipPosition="above" (click)="onClickDelete(article.article.id)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator class="paginator" [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons aria-label="Select page of periodic elements"></mat-paginator>
</div>

